const supportOrigin = process.env.NEXT_PUBLIC_BIFROST_EXTERNAL_URL

if (!supportOrigin) {
  throw new Error('NEXT_PUBLIC_BIFROST_EXTERNAL_URL is required')
}

export const CANONICAL_SUPPORT_ORIGIN = supportOrigin

export const ALLOWED_CALLBACK_ORIGINS = [
  'https://www.jusbrasil.com.br',
  'https://local.jusbrasil.com.br',
]
